<template v-if="promotion.length > 0">
  <div>
    <div :class="loadData ? 'bg-backdrop-promotion' : ''"></div>
    <div
      style="position: absolute; top: 50%; left: 50%; width: 10%; z-index: 15"
      v-show="loadData == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <md-dialog
      id="promo_manage_dlg"
      :md-active.sync="$store.getters['pmmanage/show_apv_dialog']"
      class="manage-dialog"
      :md-click-outside-to-close="false"
    >
      <div :class="checkBackdrop ? 'backdrop-manage' : ''"></div>
      <md-toolbar>
        <div class="title-panel">
          {{ promotion.promotion_code }} {{ promotion.promotion_title }}
        </div>
        <div class="sub-title"></div>
        <md-menu md-size="big">
          <md-button class="md-icon-button more-vert" md-menu-trigger>
            <md-icon>more_vert</md-icon>
          </md-button>
          <md-menu-content
            class="menu-vert-manage"
            v-if="promotion.c_user == getUserDB.code"
          >
            <!-- <md-menu-item v-for="rows in $store.getters['pmmanage/mng_condition_list']" :key="`conditionmenu_${rows.id}`" @click="selectedCondition($store.getters['pmmanage/promo_selected'] , rows)">{{rows.name}}</md-menu-item> -->
            <div
              v-for="rows in $store.getters['pmmanage/mng_condition_list']"
              :key="rows.id"
            >
              <!-- <div v-if="promotion.type == 'Pending' || promotion.type == 'Active'"> -->
              <div v-if="promotion.type == 'Pending'">
                <!-- <md-menu-item v-if="rows.name != 'Edit' && rows.name != 'Delete'" @click="selectedCondition($store.getters['pmmanage/promo_selected'] , rows)">
                                {{rows.name}}
                </md-menu-item>-->
                <template v-if="rows.name != 'Edit' && rows.name != 'Delete'">
                  <md-menu-item
                    class="latofont"
                    v-if="
                      rows.name == 'Track' &&
                      (!promotion.tracking || promotion.tracking == 'false')
                    "
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                  <md-menu-item
                    class="latofont"
                    v-if="
                      rows.name == 'Cancel Tracking' &&
                      (promotion.tracking || promotion.tracking == 'true')
                    "
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                  <md-menu-item
                    class="latofont"
                    v-if="rows.name == 'Duplicate'"
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                </template>
              </div>
              <div v-else-if="promotion.type == 'Active'">
                <!-- <md-menu-item v-if="rows.name != 'Delete'" @click="selectedCondition($store.getters['pmmanage/promo_selected'] , rows)">
                                {{rows.name}}
                </md-menu-item>-->
                <template v-if="rows.name != 'Delete'">
                  <md-menu-item
                    class="latofont"
                    v-if="
                      rows.name == 'Track' &&
                      (!promotion.tracking || promotion.tracking == 'false')
                    "
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                  <md-menu-item
                    class="latofont"
                    v-if="
                      rows.name == 'Cancel Tracking' &&
                      (promotion.tracking || promotion.tracking == 'true')
                    "
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                  <!-- <md-menu-item class="latofont" v-if="rows.name == 'Duplicate' || rows.name == 'Edit'" @click="selectedCondition($store.getters['pmmanage/promo_selected'] , rows)"> -->
                  <md-menu-item
                    class="latofont"
                    v-if="
                      rows.name == 'Duplicate' || rows.name == 'Inactive Promo'
                    "
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                </template>
              </div>
              <div
                v-else-if="
                  promotion.type_active == true || promotion.type == 'Return'
                "
              >
                <template v-if="rows.name != 'Delete'">
                  <md-menu-item
                    class="latofont"
                    v-if="
                      rows.name == 'Track' &&
                      (!promotion.tracking || promotion.tracking == 'false')
                    "
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                  <md-menu-item
                    class="latofont"
                    v-if="
                      rows.name == 'Cancel Tracking' &&
                      (promotion.tracking || promotion.tracking == 'true')
                    "
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                  <md-menu-item
                    class="latofont"
                    v-if="rows.name == 'Duplicate' || rows.name == 'Edit'"
                    @click="
                      selectedCondition(
                        $store.getters['pmmanage/promo_selected'],
                        rows
                      )
                    "
                    >{{ rows.name }}</md-menu-item
                  >
                </template>
              </div>
              <div v-else>
                <!-- <md-menu-item @click="selectedCondition($store.getters['pmmanage/promo_selected'] , rows)">
                                {{rows.name}}
                </md-menu-item>-->
                <md-menu-item
                  class="latofont"
                  v-if="
                    rows.name == 'Track' &&
                    (!promotion.tracking || promotion.tracking == 'false')
                  "
                  @click="
                    selectedCondition(
                      $store.getters['pmmanage/promo_selected'],
                      rows
                    )
                  "
                  >{{ rows.name }}</md-menu-item
                >
                <md-menu-item
                  class="latofont"
                  v-if="
                    rows.name == 'Cancel Tracking' &&
                    (promotion.tracking || promotion.tracking == 'true')
                  "
                  @click="
                    selectedCondition(
                      $store.getters['pmmanage/promo_selected'],
                      rows
                    )
                  "
                  >{{ rows.name }}</md-menu-item
                >
                <md-menu-item
                  class="latofont"
                  v-if="
                    rows.name == 'Duplicate' ||
                    rows.name == 'Edit' ||
                    rows.name == 'Delete'
                  "
                  @click="
                    selectedCondition(
                      $store.getters['pmmanage/promo_selected'],
                      rows
                    )
                  "
                  >{{ rows.name }}</md-menu-item
                >
              </div>
            </div>
          </md-menu-content>
          <md-menu-content class="menu-vert-manage" v-else>
            <div
              v-for="rows in $store.getters['pmmanage/mng_condition_list']"
              :key="rows.id"
            >
              <!-- <md-menu-item v-if="rows.name == 'Track' || rows.name == 'Duplicate'" @click="selectedCondition($store.getters['pmmanage/promo_selected'] , rows)">
                            {{rows.name}}
              </md-menu-item>-->
              <md-menu-item
                class="latofont"
                v-if="
                  rows.name == 'Track' &&
                  (!promotion.tracking || promotion.tracking == 'false')
                "
                @click="
                  selectedCondition(
                    $store.getters['pmmanage/promo_selected'],
                    rows
                  )
                "
                >{{ rows.name }}</md-menu-item
              >
              <md-menu-item
                class="latofont"
                v-if="
                  rows.name == 'Cancel Tracking' &&
                  (promotion.tracking || promotion.tracking == 'true')
                "
                @click="
                  selectedCondition(
                    $store.getters['pmmanage/promo_selected'],
                    rows
                  )
                "
                >{{ rows.name }}</md-menu-item
              >
              <md-menu-item
                class="latofont"
                v-if="rows.name == 'Duplicate'"
                @click="
                  selectedCondition(
                    $store.getters['pmmanage/promo_selected'],
                    rows
                  )
                "
                >{{ rows.name }}</md-menu-item
              >
            </div>
          </md-menu-content>
        </md-menu>
      </md-toolbar>

      <div class="content-promotion-manage">
        <md-card class="main-content" style="margin-top: 20px">
          <md-card-header>
            <md-card-header-text>
              <div class="mktops-subheader-text">Basic Info</div>
            </md-card-header-text>
            <!-- <md-button v-if="(promotion.type != 'Pending') && (promotion.c_user == getUserDB.code)" class="md-button md-primary" @click="goStep('step-1')">EDIT</md-button> -->
            <md-button
              v-if="
                promotion.type != 'Pending' &&
                promotion.type != 'Active' &&
                promotion.c_user == getUserDB.code
              "
              class="md-button md-primary"
              @click="goStep('step-1')"
              >EDIT</md-button
            >
            <div v-else class="btn-none"></div>
          </md-card-header>
          <div
            class="md-layout"
            style="
              padding-left: 20px;
              padding-right: 20px;
              padding-bottom: 10px;
            "
          >
            <div class="md-layout-item md-size-5">
              <div class="mktops-square-blue">
                <md-icon>show_chart</md-icon>
              </div>
            </div>
            <div
              class="md-layout-item md-size-95 mktops-produce-table"
              style="padding-left: 10px"
            >
              <table class="mktops-info-table">
                <tr>
                  <th class="md-tab-blue-text table" style="width: 20%">
                    Promotion Code
                  </th>
                  <th class="md-tab-blue-text table" style="width: 30%">
                    Promotion Title
                  </th>
                  <!-- <th class="md-tab-blue-text table" style="width: 40%;">Promotion Detail</th> -->
                  <th
                    class="md-tab-blue-text table"
                    style="width: 24%; padding-left: 10px"
                  >
                    Start Date
                  </th>
                  <th class="md-tab-blue-text table" style="width: 12%">
                    End Date
                  </th>
                </tr>
                <tr class="info-table-content">
                  <td style="width: 20%" class="kanitfont">
                    {{ promotion.promotion_code }}
                  </td>
                  <td style="width: 30%" class="kanitfont">
                    {{ promotion.promotion_title }}
                  </td>
                  <!-- <td style="width: 40%;">{{promotion.promotion_detail}}</td> -->
                  <td style="width: 24%; padding-left: 10px">
                    {{ convertDate(promotion.startdate) }}
                  </td>
                  <td style="width: 12%">
                    {{ convertDate(promotion.enddate) }}
                  </td>
                </tr>
              </table>

              <!-- <table class="mktops-info-table">
                            <tr>
                                <th class="md-tab-blue-text table" style="width: 100%;">Promotion Title</th>
                            </tr>
                            <tr class="info-table-content">
                                <td style="width: 100%;">{{promotion.promotion_title}}</td>
                            </tr>
              </table>-->
              <table class="mktops-info-table">
                <tr>
                  <th class="md-tab-blue-text table" style="width: 50%">
                    Promotion Detail
                  </th>
                  <th
                    class="md-tab-blue-text table"
                    style="width: 24%; padding-left: 10px"
                  >
                    Promotion Strategy
                  </th>
                  <th class="md-tab-blue-text table" style="width: 12%">
                    Create Date
                  </th>
                </tr>
                <tr class="info-table-content">
                  <td style="width: 50%" class="kanitfont -break-word">
                    {{ promotion.promotion_detail }}
                  </td>
                  <td style="width: 24%; padding-left: 10px">
                    <div style="display: flex; width: 100%;">
                      <div>
                        <i class="md-icon material-icons -list_alt"
                          style="
                            color: #b3b3b3;
                            cursor: pointer;
                            font-size: 24px !important;
                            margin-top: -2px;
                            margin-right: 7px;
                          "
                          @mouseover="handleMouseOver"
                          @mouseout="handleMouseOut"
                        >
                            info
                        </i>
                      </div>
                      <div>
                        {{ convertStrategy(promotion.promotion_type) }}
                      </div>
                      <div class="floating-data-title" v-show="showFloatingData &&
                        (descriptionPmStrategy !== '' || benefitsPmStrategy !== '')">
                      <!-- <div class="floating-data-title"> -->
                        <div style="font-weight: bold; font-size: 15px;">Description from Bard :</div>
                        <div style="margin-bottom: 15px;">{{ descriptionPmStrategy }}</div>
                        <div style="font-weight: bold; font-size: 15px;">Benefits from Bard :</div>
                        <div>{{ benefitsPmStrategy }}</div>
                      </div>
                    </div>
                  </td>
                  <td style="width: 12%">
                    {{ convertDate(promotion.c_time) }}
                  </td>
                </tr>
              </table>

              <!-- <table class="mktops-info-table" v-show="(promotion.promotion_repeat && promotion.promotion_repeat.length > 0)">
                            <tr>
                                <th class="md-tab-blue-text table" style="width: 18%;">Promotion Set</th>
                            </tr>
                            <tr class="info-table-head">
                                <th class="md-tab-blue-text table" style="width: 18%;">Promotion Code</th>
                                <th class="md-tab-blue-text table" style="width: 40%;">Promotion Title</th>
                                <th class="md-tab-blue-text table" style="width: 28%; padding-left: 10px;;">Conditions</th>
                            </tr>
                            <tr class="info-table-content promotion-repeat" :class="'row-bg-gray'" v-for="(items, index) in promotion.promotion_repeat" :key="index">
                                <td style="width: 18%;" class="kanitfont -break-word">{{items.promotion_code}}</td>
                                <td style="width: 40%;">{{items.promotion_title}}</td>
                                <td style="width: 28%; padding-left: 10px;">{{(items.condition == 0) ? "ต้องมี" : "มีหรือไม่มีก็ได้"}}</td>
                            </tr>
              </table>-->
              <div
                id="table-promotion-repeat"
                v-show="
                  promotion.promotion_repeat &&
                  promotion.promotion_repeat.length > 0
                "
              >
                <div id="divTableHead" class="promotion-set">
                  <div style="width: 100%">Promotion Set</div>
                </div>
                <div id="divTableHead">
                  <div style="width: 21%">Promotion Code</div>
                  <div style="width: 64.5%">Promotion Title</div>
                  <div style="width: 14.5%">Conditions</div>
                </div>
                <div id="divTableBody">
                  <div
                    :class="'row-bg-gray'"
                    v-for="(items, index) in promotion.promotion_repeat"
                    :key="index"
                  >
                    <div
                      style="width: 21%"
                      :title="items.promotion_code"
                      class="kanitfont nowrap-title"
                    >
                      {{ items.promotion_code }}
                    </div>
                    <div
                      style="width: 64.5%"
                      :title="items.promotion_title"
                      class="kanitfont nowrap-title"
                    >
                      {{ items.promotion_title }}
                    </div>
                    <div style="width: 14.5%" class="kanitfont">
                      {{ items.condition == 0 ? "ต้องมี" : "มีหรือไม่มีก็ได้" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </md-card>

        <md-card class="main-content" style="margin-top: 12px; height: 320px">
          <md-card-header>
            <md-card-header-text>
              <div class="mktops-subheader-text">Selected Products</div>
            </md-card-header-text>
            <!-- <md-button v-if="(promotion.type != 'Pending') && (promotion.c_user == getUserDB.code)" class="md-button md-primary" @click="goStep('step-2')">EDIT</md-button> -->
            <md-button
              v-if="
                promotion.type != 'Pending' &&
                promotion.type != 'Active' &&
                promotion.c_user == getUserDB.code
              "
              class="md-button md-primary"
              @click="goStep('step-2')"
              >EDIT</md-button
            >
            <div v-else class="btn-none"></div>
          </md-card-header>
          <div class="mktops-produce-table" v-if="promotion.products">
            <div id="table-manage-produce">
              <div id="divTableHead">
                <div style="width: 8%">Code</div>
                <div style="width: 29%">Description</div>
                <div
                  v-show="!showGP"
                  style="width: 6%"
                  class="-text-right"
                ></div>
                <div style="width: 7%" class="-text-right">Stock</div>
                <div style="width: 4%">Unit</div>
                <div style="width: 4%" class="-text-right">Min</div>
                <div style="width: 9%" class="-text-right">Max</div>
                <div style="width: 8%" class="-text-right">Net Price</div>
                <div style="width: 9%" class="-text-right">Defalut Price</div>
                <div style="width: 9%" class="-text-right">Promo Price</div>
                <div style="width: 7%" class="-text-right">Cost</div>
                <div v-show="showGP" style="width: 6%" class="-text-right">
                  GP.%
                </div>
              </div>
              <div id="divTableBody">
                <!-- <div :class="'row-bg-gray'" v-for="(item, pIndex) in promotion.products" :key="pIndex"> -->
                <div
                  :class="
                    item.status == 'Inactive'
                      ? '-inactive-product'
                      : 'row-bg-gray'
                  "
                  v-for="(item, pIndex) in promotion.products"
                  :key="pIndex"
                >
                  <div style="width: 8%">{{ item.code }}</div>
                  <div
                    style="width: 29%"
                    class="kanitfont nowrap-title"
                    :title="item.title_th"
                  >
                    {{ item.title_th }}
                  </div>
                  <div
                    v-show="!showGP"
                    style="width: 6%"
                    class="-text-right"
                  ></div>
                  <div style="width: 7%" class="-text-right">
                    {{ formatNumber(item.stock, 0) }}
                  </div>
                  <!-- <div style="width: 4%;">{{ item.unit }}</div> -->
                  <div style="width: 4%">{{ item.seu_code }}</div>
                  <div style="width: 4%" class="-text-right">
                    {{
                      item.min === "" && (item.min === "" || item.min !== 0)
                        ? ""
                        : formatNumber(item.min, 0)
                    }}
                  </div>
                  <div style="width: 9%" class="-text-right">
                    {{
                      item.max === "" && (item.max === "" || item.max !== 0)
                        ? ""
                        : formatNumber(item.max, 0)
                    }}
                  </div>
                  <div style="width: 8%" class="-text-right -netprice">
                    {{ formatNumber(item.netprice, 2) }}
                  </div>
                  <div style="width: 9%" class="-text-right">
                    {{ formatNumber(item.price, 2) }}
                  </div>
                  <div style="width: 9%" class="-text-right">
                    {{ formatNumber(item.promo_price, 2) }}
                  </div>
                  <div style="width: 7%" class="-text-right">
                    {{
                      item.cost_show !== ""
                        ? formatNumber(item.cost_show, 2)
                        : ""
                    }}
                  </div>
                  <div v-show="showGP" style="width: 6%" class="-text-right">
                    {{ calculateGP(item) }}
                  </div>
                </div>
              </div>
              <div id="divTableFoot">
                <div
                  style="
                    width: 37%;
                    font-weight: 400;
                    font-size: 13px;
                    color: red;
                    font-style: italic;
                  "
                >
                  *Product code ที่ถูก Inactive
                </div>
                <div
                  v-show="!showGP"
                  style="width: 6%"
                  class="-text-right"
                ></div>
                <div
                  style="
                    width: 24%;
                    font-weight: 400;
                    font-size: 13px;
                    font-style: italic;
                  "
                >
                  number of product ({{ promotion.products.length }})
                </div>
                <div style="width: 8%" class="-text-right">Sum</div>
                <div style="width: 9%" class="-text-right">{{ sumPrice }}</div>
                <div style="width: 9%" class="-text-right">
                  {{ sumPricePromo }}
                </div>
                <div style="width: 7%" class="-text-right">{{ sumCost }}</div>
                <div v-show="showGP" style="width: 6%" class="-text-right">
                  {{ sumGP }}
                </div>
              </div>
            </div>
          </div>
        </md-card>

        <md-card
          class="main-content condition-sets"
          style="margin-top: 12px; margin-bottom: 20px"
        >
          <md-card-header>
            <md-card-header-text>
              <div class="mktops-subheader-text">Condition Sets</div>
            </md-card-header-text>
            <!-- <md-button v-if="(promotion.type != 'Pending') && (promotion.c_user == getUserDB.code)" class="md-button md-primary" @click="goStep('step-3')">EDIT</md-button> -->
            <md-button
              v-if="
                promotion.type != 'Pending' &&
                promotion.type != 'Active' &&
                promotion.c_user == getUserDB.code
              "
              class="md-button md-primary"
              @click="goStep('step-3')"
              >EDIT</md-button
            >
            <div v-else class="btn-none"></div>
          </md-card-header>
          <md-tabs md-active-tab="tab-0">
            <!-- <md-tab v-for="(item , index) in promotion.sets" :key="index" :id="`tab-${index}`" :md-label="`SET ${(index+1)}`"> -->
            <md-tab
              v-for="(item, index) in promotion.sets"
              :key="index"
              :id="`tab-${index}`"
              :md-label="item.name == '' ? `SET ${index + 1}` : `${item.name}`"
            >
              <div class="md-layout-item md-layout md-gutter">
                <div
                  class="md-layout-item md-size-60"
                  style="padding-left: 0px"
                >
                  <div class="md-layout-item md-layout md-gutter">
                    <div
                      class="md-layout-item md-size-30"
                      style="padding-left: 0px"
                    >
                      <div class="md-tab-blue-text">Set</div>
                      <div class="md-tab-text" style="margin-top: 3px">
                        {{ item.name }}
                      </div>
                    </div>
                    <div class="md-layout-item md-size-70">
                      <div class="md-tab-blue-text">Default Price</div>
                      <div class="md-tab-text" style="margin-top: 3px">
                        {{ item.default_price }}
                      </div>
                    </div>
                    <div class="md-layout-item md-size-100 rows-item">
                      <div class="mktops-text-condition" style="display: flex">
                        <div style="width: 25%; padding-top: 10px">
                          Conditions
                        </div>
                        <div>
                          <!-- <md-checkbox v-model="item.mix_set" style="margin-bottom: 0px; margin-top: 9px; margin-left: 15px;" disabled>Mix set</md-checkbox> -->
                        </div>
                      </div>
                    </div>
                    <div v-if="item.conditions.length > 0">
                      <template
                        v-for="(
                          item_condition, index_condition
                        ) in item.conditions"
                      >
                        <div
                          v-if="
                            item_condition.type != 'Count Item' &&
                            item_condition.type != 'Count Value' &&
                            item_condition.type != 'Count Mix'
                          "
                          :key="`condition_${index_condition}`"
                          class="md-layout-item md-size-100 step-content-line"
                        >
                          <div class="section-sub-line"></div>
                          <label class="mktops-text-qty mr-20">
                            {{ item_condition.type }}
                          </label>
                          <label
                            class="md-tab-blue-text"
                            style="margin-right: 5px"
                            >Min</label
                          >
                          <label class="md-tab-text mr-20">
                            {{ item_condition.min }}
                          </label>
                          <label
                            class="md-tab-blue-text"
                            style="margin-right: 5px"
                            >Max</label
                          >
                          <label class="md-tab-text">
                            {{ item_condition.max }}
                          </label>
                        </div>

                        <template
                          v-else-if="item_condition.type == 'Count Mix'"
                        >
                          <div
                            class="md-layout-item md-size-100 step-content-line"
                          >
                            <div class="section-sub-line"></div>
                            <label class="mktops-text-qty mr-20"
                              >Count Item (≥)</label
                            >
                            <label class="md-tab-text">
                              {{ item_condition.count }}
                            </label>
                          </div>
                          <div
                            class="md-layout-item md-size-100 step-content-line"
                          >
                            <div class="section-sub-line"></div>
                            <label class="mktops-text-qty mr-20">QTY</label>
                            <label
                              class="md-tab-blue-text"
                              style="margin-right: 5px"
                              >Min</label
                            >
                            <label class="md-tab-text mr-20">
                              {{ item_condition.min }}
                            </label>
                            <label
                              class="md-tab-blue-text"
                              style="margin-right: 5px"
                              >Max</label
                            >
                            <label class="md-tab-text">
                              {{ item_condition.max }}
                            </label>
                          </div>
                          <div
                            class="md-layout-item md-size-100 step-content-line"
                          >
                            <div class="section-sub-line"></div>
                            <label class="mktops-text-qty mr-20">Value</label>
                            <label
                              class="md-tab-blue-text"
                              style="margin-right: 5px"
                              >Min</label
                            >
                            <label class="md-tab-text mr-20">
                              {{ item_condition.min_value }}
                            </label>
                            <label
                              class="md-tab-blue-text"
                              style="margin-right: 5px"
                              >Max</label
                            >
                            <label class="md-tab-text">
                              {{ item_condition.max_value }}
                            </label>
                          </div>
                        </template>

                        <template v-else>
                          <div
                            class="md-layout-item md-size-100 step-content-line"
                          >
                            <div class="section-sub-line"></div>
                            <label class="mktops-text-qty mr-20"
                              >Count Item (≥)</label
                            >
                            <label class="md-tab-text">
                              {{ item_condition.count }}
                            </label>
                          </div>
                          <div
                            class="md-layout-item md-size-100 step-content-line"
                          >
                            <div class="section-sub-line"></div>
                            <label
                              v-if="item_condition.type == 'Count Item'"
                              class="mktops-text-qty mr-20"
                              >QTY</label
                            >
                            <label
                              v-if="item_condition.type == 'Count Value'"
                              class="mktops-text-qty mr-20"
                              >Value</label
                            >
                            <label
                              class="md-tab-blue-text"
                              style="margin-right: 5px"
                              >Min</label
                            >
                            <label class="md-tab-text mr-20">
                              {{ item_condition.min }}
                            </label>
                            <label
                              class="md-tab-blue-text"
                              style="margin-right: 5px"
                              >Max</label
                            >
                            <label class="md-tab-text">
                              {{ item_condition.max }}
                            </label>
                          </div>
                        </template>
                      </template>
                    </div>
                    <div v-else>
                      <div class="md-layout-item md-size-100 step-content-line">
                        <div class="section-sub-line"></div>
                        <label class="mktops-text-qty mr-20 -donthavedata"
                          >Not have Conditions.</label
                        >
                      </div>
                    </div>

                    <div class="md-layout-item md-size-100 rows-item">
                      <div class="mktops-text-condition">Promotions</div>
                    </div>

                    <div
                      v-for="(
                        item_promotion, index_promotion
                      ) in item.promotions"
                      :key="`promotion_${index_promotion}`"
                      :class="
                        item_promotion.type == 'Free item'
                          ? 'md-layout-item md-size-100 fix-height'
                          : 'md-layout-item md-size-100 step-content-line'
                      "
                    >
                      <template v-if="item_promotion.type == 'Discount'">
                        <div class="section-sub-line"></div>
                        <label class="mktops-text-qty mr-20">
                          {{ item_promotion.type }}
                        </label>
                        <!-- <label class="md-tab-blue-text" style="margin-right:5px">Percent</label> -->
                        <label class="md-tab-text"
                          >{{ item_promotion.value }} %</label
                        >
                      </template>
                      <template v-else-if="item_promotion.type == 'Net Price'">
                        <div class="section-sub-line"></div>
                        <label class="mktops-text-qty mr-20">
                          {{ item_promotion.type }}
                        </label>
                        <!-- <label class="md-tab-blue-text" style="margin-right:5px">Point</label> -->
                        <label class="md-tab-text kanitfont"
                          >{{ item_promotion.value }} {{ $t('currency.symbol') }}</label
                        >
                      </template>
                      <template v-else-if="item_promotion.type == 'Free item'">
                        <div class="free-item">
                          <div class="section-sub-line"></div>
                          <div
                            class="mktops-text-qty mr-20"
                            style="margin-right: 0px"
                          >
                            {{ item_promotion.type }}
                          </div>
                          <div
                            v-show="item_promotion.number_of_item_flag == true"
                            style="
                              text-align: right;
                              padding-top: 2px;
                              width: 81%;
                            "
                          >
                            Pick up &ensp;
                            {{
                              item_promotion.number_of_item == ""
                                ? "-"
                                : item_promotion.number_of_item
                            }}
                            &ensp; item from all list
                          </div>
                          <div
                            v-show="item_promotion.ratio_flage == true"
                            style="
                              text-align: right;
                              padding-top: 2px;
                              width: 81%;
                            "
                          >
                            Ratio &ensp;
                            {{
                              item_promotion.ratio !== undefined
                                ? item_promotion.ratio[0] +
                                  " : " +
                                  item_promotion.ratio[1]
                                : ""
                            }}
                          </div>
                        </div>
                        <div id="table-manage-promotions">
                          <div id="divTableHead">
                            <div style="width: 15%">Code</div>
                            <div style="width: 55%">Description</div>
                            <div style="width: 15%" class="-text-center">
                              Unit
                            </div>
                            <div style="width: 15%" class="-text-right">
                              QTY
                            </div>
                            <!-- <div style="width: 13%;" class="-text-center">Ratio</div> -->
                          </div>
                          <div id="divTableBody">
                            <div
                              :class="
                                item.status == 'Inactive'
                                  ? '-inactive-product'
                                  : 'row-bg-gray'
                              "
                              v-for="(item, csIndex) in item_promotion.value"
                              :key="csIndex"
                            >
                              <div style="width: 15%">{{ item.code }}</div>
                              <div
                                style="width: 55%"
                                class="kanitfont nowrap-title"
                                :title="item.desc"
                              >
                                {{ item.desc }}
                              </div>
                              <div style="width: 15%" class="-text-center">
                                {{ item.unit }}
                              </div>
                              <div style="width: 15%" class="-text-right">
                                {{
                                  item.qty == null || item.qty == ""
                                    ? "-"
                                    : item.qty
                                }}
                              </div>
                              <!-- <div style="width: 13%;" class="-text-center">{{ displayRatio(item.ratio) }}</div> -->
                            </div>
                          </div>
                          <!-- <div style="font-weight: 400; font-size: 13px; color: red; font-style: italic; margin-top: 10px;">*Product code ที่ถูก Inactive</div> -->
                          <div
                            style="
                              display: flex;
                              font-weight: 400;
                              font-size: 13px;
                              font-style: italic;
                              margin-top: 10px;
                            "
                          >
                            <div style="width: 55%; color: red">
                              *Product code ที่ถูก Inactive
                            </div>
                            <div style="width: 45%">
                              number of product ({{
                                item_promotion.value.length
                              }})
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      v-if="item.promotions.length == 0"
                      class="md-layout-item md-size-100"
                    >
                      <template>
                        <div class="free-item">
                          <div class="section-sub-line"></div>
                          <label class="mktops-text-qty mr-20 -donthavedata"
                            >Do not have Discount.</label
                          >
                        </div>
                      </template>

                      <template>
                        <div class="free-item">
                          <div class="section-sub-line"></div>
                          <label class="mktops-text-qty mr-20 -donthavedata"
                            >Do not have Net Price.</label
                          >
                        </div>
                      </template>

                      <template>
                        <div class="free-item">
                          <div class="section-sub-line"></div>
                          <div class="mktops-text-qty mr-20 -donthavedata">
                            Do not have Free item.
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="md-layout-item md-size-40 section-line">
                  <div class="mktops-text-condition">Customer Groups</div>
                  <div class="md-layout filter-chips">
                    <md-chip
                      style="display: inline-grid; margin-left: 0px"
                      class="md-primary"
                      v-for="(customer, index_customer) in item.customers"
                      :key="`customer_${index_customer}`"
                    >
                      ({{ index_customer + 1 }})
                      {{ customer.group_name }}
                    </md-chip>
                  </div>
                </div>
              </div>
            </md-tab>
          </md-tabs>
        </md-card>

        <md-card
          v-show="dataMemo !== undefined && dataMemo.length > 0"
          class="main-content"
          style="margin-top: 12px"
        >
          <md-card-header>
            <md-card-header-text>
              <div class="mktops-subheader-text">Memo Comment</div>
            </md-card-header-text>
          </md-card-header>

          <div class="content-memo">
            <!-- <div v-for="(item, index) in dataMemo" :key="index" :class="(index % 2 == 1) ? 'item-card row-bg-green' : 'item-card row-bg-orange'"> -->
            <div
              v-for="(item, index) in dataMemo"
              :key="index"
              :class="classMemoRow(item.act_status)"
            >
              <div style="display: flex; padding-top: 10px">
                <div class="-left-panel">
                  <div class="-circle-gray"></div>
                </div>
                <div class="-right-panel">
                  <div class="-title" style="font-family: kanit !important">
                    {{ item.firstname }} {{ item.u_user }}
                    <span :class="classMemoStatus(item.act_status)">
                      {{ memoStatus(item.act_status) }}
                    </span>
                  </div>
                  <div class="-date">{{ convertDateMemo(item.c_date) }}</div>
                </div>
              </div>
              <div class="-comment" style="font-family: kanit !important">
                {{ item.comment }}
              </div>
            </div>
          </div>
        </md-card>
      </div>

      <md-dialog-actions class="-action">
        <!-- {{getUserDB.code}} - {{getUserDB.boss_code}} -->
        <!-- {{getUserDB.code}} - {{promotion.approve_by }} -->
        <div
          class="select-approval"
          v-show="
            ((promotion.type == 'Draft' || promotion.type == 'Return') &&
              promotion.c_user == getUserDB.code) ||
            (promotion.type == 'Pending' &&
              getUserDB.code === promotion.approve_by &&
              getUserDB.code !== '391004')
          "
        >
          <!-- <multiselect
            v-model="selectedPeople"
            label="firstname"
            track-by="code"
            placeholder="Approval Name"
            :open-direction="'top'"
            :options="optionsPeople"
            :searchable="true"
            :max-height="180"
            :show-no-results="false"
            :custom-label="customLabelPeople"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <div class="-label">
                  {{ option.firstname }} {{ option.lastname }}
                </div>
              </div>
            </template>
          </multiselect>-->
          <md-field>
            <md-select v-model="selectedPeople">
              <md-option
                v-for="(item, index) in optionsPeople"
                :key="index"
                v-bind:value="item.code"
                >{{ item.firstname }} {{ item.lastname }}</md-option
              >
            </md-select>
          </md-field>
        </div>
        <!-- <md-button class="-cancel" @click="clickClose()">CLOSE</md-button> -->

        <!-- v-if="
        (promotion.type == 'Draft' || promotion.type == 'Return') &&
            promotion.c_user == getUserDB.code
        "-->
        <!-- promotion.approve_by == getUserDB.code -->
        <md-button
          v-if="
            ((promotion.type == 'Draft' || promotion.type == 'Return') &&
              promotion.c_user == getUserDB.code) ||
            (promotion.type == 'Pending' &&
              getUserDB.code === promotion.approve_by &&
              getUserDB.code !== '391004')
          "
          class="-approve"
          @click="cilckSendToApprove()"
          :disabled="saveDisabled"
          >SEND TO APPROVE</md-button
        >

        <md-button
          v-if="
            promotion.type == 'Pending' &&
            promotion.approve_by == getUserDB.code
          "
          class="-approve"
          @click="clickApprove()"
          >APPROVE</md-button
        >

        <md-button
          v-if="
            promotion.type == 'Pending' &&
            promotion.approve_by == getUserDB.code
          "
          class="-reject"
          @click="clickReject()"
          >REJECT</md-button
        >

        <md-button class="-cancel" @click="clickClose()">CLOSE</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="active"
      md-title="Confirm"
      :md-content="dialog_title"
      md-confirm-text="Sure"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
    <md-dialog-alert
      :md-active.sync="alert"
      md-title="Alert!"
      :md-content="dialog_title"
    />

    <md-dialog-confirm
      :md-active.sync="dialogActivePromo"
      md-title="Confirm"
      md-content="Are you sure to inactive ?"
      md-confirm-text="Sure"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirmInAvtivePromo"
    />

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
    </md-snackbar>

    <md-dialog
      :md-active.sync="$store.getters['pmmanage/show_memo_dialog']"
      class="promo-memo"
      :style="checkApprove ? 'width: 30%;' : ''"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title :style="checkApprove ? 'margin-bottom: 40px;' : ''">
        {{ alertMemo }}
      </md-dialog-title>

      <div v-show="!checkApprove" class="layout-dialog">
        <textarea
          v-model="memoComment"
          placeholder="Please enter the reason."
        ></textarea>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="md-primary -cancel" @click="onClickClose()"
          >CLOSE</md-button
        >
        <md-button
          :class="colorButton()"
          @click="onSaveMemo()"
          :disabled="saveDisabled"
          >{{ buttonName }}</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import router from "@/router";
import moment from "moment-timezone";
import Vue from "vue";
import userService from "@/services/user";
import promotionService from "@/services/promotion";
import CipherService from "@/services/cipher";

export default {
  name: "approve-dialog",
  created() {
    let self = this;
    self.getListPmStrategy();
    self.dataUser = this.$jwt.decode(localStorage.getItem("token"));
    CipherService.getBossCode(self.dataUser.code)
      .then((response) => {
        self.dataUser = {
          code: self.dataUser.code,
          boss_code:
            response.resource.length > 0 ? response.resource[0].boss_code : "",
        };

        // if (
        //   self.dataUser.boss_code !== undefined &&
        //   self.dataUser.boss_code !== "" &&
        //   self.dataUser.boss_code !== null
        // ) {
        promotionService.getApproveBy(self.dataUser).then((response) => {
          if (response && response.length > 0) {
            self.optionsPeople = response;

            /*-- START New Flow Approve --*/
            // if (this.value["approve_by"] === undefined) {
            if (this.value === undefined) {
              let index = this.optionsPeople.findIndex(
                (item) => item.code === self.dataUser.boss_code
              );
              if (index > -1) {
                this.selectedPeople = this.optionsPeople[index].code;
              } else {
                this.selectedPeople = this.optionsPeople[0].code;
              }
            } else {
              let index = this.optionsPeople.findIndex(
                (item) => item.code === this.value["approve_by"]
              );
              if (index > -1) {
                this.selectedPeople = this.optionsPeople[index].code;
              } else {
                this.selectedPeople = this.optionsPeople[0].code;
              }
            }
            /*-- END New Flow Approve --*/
          }
        });
        // }
      })
      .catch((error) => console.log(error));
    if (self.dataUser.group !== "Trade Marketer") {
      this.showGP = true;
    }
  },
  computed: {
    loadData() {
      return this.$store.getters["pmmanage/loadData"];
    },
    promotion() {
      /* sum total cost & price */
      let datas = this.$store.getters["pmmanage/promo_selected"];

      /*-- START New Flow Approve --*/
      if (datas.approve_by === undefined) {
        let index = this.optionsPeople.findIndex(
          (item) => item.code === this.dataUser.boss_code
        );
        if (index > -1) {
          this.selectedPeople = this.optionsPeople[index].code;
        }
      } else {
        let index = this.optionsPeople.findIndex(
          (item) => item.code === datas.approve_by
        );
        if (index > -1) {
          this.selectedPeople = this.optionsPeople[index].code;
        }
      }
      /*-- END New Flow Approve --*/

      if (datas.products) {
        let self = this;
        let sum_price = 0;
        let sum_price_promo = 0;
        let sum_cost_effective = 0;
        datas.products.forEach(function (value, key) {
          // sum_cost += parseFloat((value.cost) ? self.calc(value.cost) : 0);
          // sum_price += parseFloat((value.price) ? self.calc(value.price) : 0);
          // gp = (value.cost) ? ((parseFloat(value.cost) - parseFloat(value.price)) / parseFloat(value.cost)) * 100 : 0;
          // sum_gp += parseFloat(self.formatNumber(gp, 2));

          /* START Change format string > float (from database) :: 11.03.19 */
          // sum_cost += (value.cost) ? parseFloat(self.formatNumber(value.cost).replace(',','')) : 0;
          // sum_price += (value.price) ? parseFloat(self.formatNumber(value.price).replace(',','')) : 0;
          sum_cost_effective +=
            value.cost_show !== ""
              ? parseFloat(value.cost_show)
              : value.cost
              ? parseFloat(value.cost)
              : 0;
          sum_price += value.price ? parseFloat(value.price) : 0;
          sum_price_promo += value.promo_price
            ? parseFloat(value.promo_price)
            : 0;
        });

        this.sumCost = this.formatNumber(sum_cost_effective, 2);
        this.sumPrice = this.formatNumber(sum_price, 2);
        this.sumPricePromo = this.formatNumber(sum_price_promo, 2);
        // this.sumGP = this.formatNumber(sum_gp, 2);
        //this.sumGP = this.formatNumber(((parseFloat(sum_cost) - parseFloat(sum_price)) / parseFloat(sum_cost)) * 100, 2);
        let item = {
          cost: sum_cost_effective,
          cost_show: "",
          promo_price: sum_price_promo,
        };
        this.sumGP = this.calculateGP(item);
        /* END Change format string > float (from database) :: 11.03.19 */
      }

      this.dataMemo = this.$store.getters["pmmanage/promo_selected"].wf;
      return this.$store.getters["pmmanage/promo_selected"];
    },
    getUserDB() {
      return this.$store.getters["pmmanage/userdb"];
    },
  },
  watch: {
    refreshPage() {
      return this.$store.getters["pmmanage/promo_selected"];
    },
  },
  data() {
    return {
      dataUser: [],
      selectedPeople: [],
      optionsPeople: [],
      checkApprove: false,
      saveDisabled: false,
      promoData: [],
      dialogActivePromo: false,
      dataMemo: 0,
      alertMemo: "",
      buttonName: "Save",
      memoComment: "",
      showSnackbar: false,
      position: "center",
      duration: 3500,
      isInfinity: false,
      dContent: "",
      refreshPage: false,
      userDB: null,
      userBossDB: null,
      showInfo: false,
      showSelectedProduct: true,
      showConditionSets: true,
      checkValTmp: false,
      dialog_title: null,
      alert: false,
      active: false,
      checkEvent: "edit",
      promotion_index: null,
      checkBackdrop: false,
      vSetType: "Pending",
      promotionActive: false,
      index_dup_code: 0,
      showGP: false,
      sumCost: 0,
      sumPrice: 0,
      sumPricePromo: 0,
      sum_gp: 0,
      optionsPmStrategy: [],
      descriptionPmStrategy: "",
      benefitsPmStrategy: "",
      showFloatingData: false
    };
  },
  methods: {
    getListPmStrategy() {
      promotionService.getPmStrategy()
        .then((response) => {
          if (response) {
            this.optionsPmStrategy = response;
          }
        })
        .catch();
    },
    customLabelPeople({ firstname, lastname }) {
      return `${firstname} ${lastname}`;
    },
    clearAll(id, type) {
      this.selectedPeople = [];
    },
    classMemoStatus(status) {
      if (status == "Draft") {
        return "memo-chip -gray";
      } else if (status == "Active") {
        return "memo-chip -green";
      } else if (status == "Return") {
        return "memo-chip -red";
      } else if (status == "Pending") {
        return "memo-chip -yellow";
      } else if (status == "Inactive") {
        return "memo-chip -blue";
      }
    },
    classMemoRow(status) {
      if (status == "Draft") {
        return "item-card row-bg-gray";
      } else if (status == "Active") {
        return "item-card row-bg-green";
      } else if (status == "Return") {
        return "item-card row-bg-red";
      } else if (status == "Pending") {
        return "item-card row-bg-yellow";
      } else if (status == "Inactive") {
        return "item-card row-bg-blue";
      } else {
        return "item-card row-bg-gray";
      }
    },
    memoStatus(status) {
      if (status == "Draft") {
        return "Draft";
      } else if (status == "Active") {
        return "Approve";
      } else if (status == "Return") {
        return "Reject";
      } else if (status == "Pending") {
        return "Send to approve";
      } else if (status == "Inactive") {
        return "Inactive";
      }
    },
    colorButton() {
      if (this.checkEvent == "Edit") {
        return "md-primary -save";
      } else if (this.checkEvent == "Approve") {
        return "md-primary -green";
      } else if (this.checkEvent == "Reject") {
        return "md-primary -red";
      }
    },
    async onSaveMemo() {
      if (this.checkEvent == "Reject" && this.memoComment == "") {
        this.dContent = "Please enter the reason.";
        this.showSnackbar = true;
        return false;
      }

      this.saveDisabled = true;
      this.$store.commit("pmmanage/loadingPage", true);

      this.promotion["type_active"] = false;

      if (
        this.checkEvent == "Edit" ||
        this.checkEvent == "Approve" ||
        this.checkEvent == "Reject"
      ) {
        if (
          this.optionsPeople.length > 0 &&
          this.selectedPeople !== undefined &&
          this.checkEvent !== "Approve" &&
          this.checkEvent !== "Reject"
        ) {
          this.promotion["approve_by"] = this.selectedPeople;
        }

        this.$store.dispatch("pmcreate/setFormatDate");
        this.$store.commit("pmcreate/setPromotion", this.promotion);
        this.$store.commit("pmcreate/setComment", this.memoComment);
        this.$store.commit("pmcreate/setType", this.vSetType);
        this.$store.commit("pmcreate/setStatusAction", "edit");
        this.$store.dispatch("pmcreate/update", {
          field: "promotion_active",
          value: this.promotionActive,
        });
        let rs_save = await this.$store.dispatch(
          "pmcreate/createPromotionToServer"
        );
        if (rs_save === false) {
          this.$store.commit("pmmanage/loadingPage", false);
          this.dContent = "Can not get approve by.";
          this.showSnackbar = true;
          this.saveDisabled = false;
          this.$store.commit("pmmanage/closeMemoDialog");
          this.checkBackdrop = false;
          return false;
        }

        let dataStore = this.$store.getters["pmmanage/promotions"];
        let setDataRow = this.$store.getters["pmmanage/promotions"].map(function (e) {
        // let dataStore = this.$store.getters["pmmanage/display_promotions"];
        // let setDataRow = this.$store.getters["pmmanage/display_promotions"].map(function (e) {
            return e._id;
          })
          .indexOf(this.promotion._id);
        dataStore[setDataRow].type = this.vSetType;
        dataStore[setDataRow].promotion_active = this.promotionActive;

        this.$store.commit("pmmanage/setPromotions", dataStore);
        this.$store.commit("pmmanage/setDisplayPromotions", []);
        this.$store.commit("pmmanage/sendApvDialog");

        this.$store.dispatch("pmmanage/getPromotions");
      } else if (this.checkEvent == "Delete") {
        this.$store.dispatch("pmmanage/deletePromotion", {
          promotion: this.promotion,
          index: this.promotion_index,
        });
        this.$store.commit("pmmanage/sendApvDialog");
      }
      this.checkBackdrop = false;
      this.saveDisabled = false;
      this.$store.commit("pmmanage/loadingPage", false);
      this.$store.commit("pmmanage/closeMemoDialog");
      this.memoComment = "";
      this.checkApprove = false;
    },
    onClickClose() {
      this.checkBackdrop = false;
      this.checkApprove = false;
      this.$store.commit("pmmanage/closeMemoDialog");
      // this.$store.commit('pmmanage/closeApvDialog');
    },
    calc(num) {
      num = num.toString(); //If it's not already a String
      num = num.slice(0, num.indexOf(".") + 3); //With 3 exposing the hundredths place
      return Number(num); //If you need it back as a Number
    },
    calculateGP(item) {
      // let cal = (cost == 0) ? 0 : ((this.calc(cost) - this.calc(price) ) / this.calc(cost) ) * 100;
      // let cal = (cost == 0) ? 0 : ((parseFloat(cost) - parseFloat(price)) / parseFloat(cost)) * 100;

      /* Change formula 14.05.2019 */
      /* Change 04.05.2026 :: cost ยึด cost_show ให้ตรงกับคอลัมน์ Cost บนจอ */
      const rawCost =
        item.cost_show !== "" ? item.cost_show : item.cost;
      let comCOST = parseFloat(
        this.formatNumber(rawCost, 2).replace(/,/g, "")
      );
      let COST = Math.round(parseFloat(comCOST) * 100) / 100;
      let comA3 = parseFloat(
        this.formatNumber(item.promo_price, 2).replace(/,/g, "")
      );
      let A3 = Math.round(parseFloat(comA3) * 100) / 100;
      let gp = A3 == 0 ? 0 : ((A3 - COST) / A3) * 100;

      return this.formatNumber(gp, 2);
    },
    onConfirmInAvtivePromo() {
      this.checkBackdrop = false;

      let user = Vue.$jwt.decode(localStorage.getItem("token"));
      let datas = {
        _id: this.promoData._id,
        promotion_code: this.promoData.promotion_code,
        u_code: user.code,
        type_active: true,
      };
      promotionService.updateTypeActive(datas);

      this.promotion.type_active = true;
      promotionService.updateStatusInactivePromo(this.promoData._id);
      router.replace("/promotion/create");
      this.$store.commit("pmcreate/setStatusAction", "edit");
      this.$store.commit("pmcreate/setPromotion", this.promotion);
      this.$store.commit("pmcreate/setStep", "step-1");
    },
    onConfirm() {
      if (this.checkEvent == "Delete") {
        this.$store
          .dispatch("pmmanage/deletePromotion", {
            promotion: this.promotion,
            index: this.promotion_index,
          })
          .then((rs) => {
            this.$store.dispatch("pmmanage/getPromotions");
            this.$store.commit("pmmanage/sendApvDialog");
            this.checkBackdrop = false;
            return false;
          });
      } else {
        this.$store.commit("pmmanage/openMemoDialog");
        this.checkBackdrop = true;

        if (this.checkEvent == "Edit") {
          this.buttonName = "SAVE";
        } else if (this.checkEvent == "Approve") {
          this.buttonName = "SEND TO APPROVE";
        } else if (this.checkEvent == "Reject") {
          this.buttonName = "REJECT";
        }
        this.checkBackdrop = false;
      }

      // if (this.checkEvent == "Edit" || this.checkEvent == "Approve" || this.checkEvent == "Reject") {
      //     this.$store.dispatch('pmcreate/setFormatDate');
      //     this.$store.commit("pmcreate/setPromotion", this.promotion);
      //     this.$store.commit('pmcreate/setType', this.vSetType);
      //     this.$store.commit("pmcreate/setStatusAction", "edit");
      //     this.$store.dispatch("pmcreate/update", {
      //         field: "promotion_active",
      //         value: this.promotionActive
      //     });
      //     this.$store.dispatch('pmcreate/createPromotionToServer')

      //     // let dataStore = this.$store.getters["pmmanage/promotions"];
      //     // let setDataRow = this.$store.getters["pmmanage/promotions"].map(function (e) {
      //     let dataStore = this.$store.getters["pmmanage/display_promotions"];
      //     let setDataRow = this.$store.getters["pmmanage/display_promotions"].map(function (e) {
      //         return e._id;
      //     }).indexOf(this.promotion._id);
      //     dataStore[setDataRow].type = this.vSetType;
      //     dataStore[setDataRow].promotion_active = this.promotionActive;

      //     this.$store.commit("pmmanage/setPromotions", dataStore);
      //     this.$store.commit("pmmanage/setDisplayPromotions", []);
      //     this.$store.commit('pmmanage/sendApvDialog');

      // }
      // else if (this.checkEvent == "Delete") {
      //     this.$store.dispatch("pmmanage/deletePromotion", {
      //         promotion: this.promotion,
      //         index: this.promotion_index
      //     });
      //     this.$store.commit('pmmanage/sendApvDialog');
      // }
      // this.checkBackdrop = false;
    },
    onCancel() {
      this.checkBackdrop = false;
    },
    clickApprove() {
      this.$store.commit("pmmanage/openMemoDialog");
      this.checkEvent = "Approve";
      this.vSetType = "Active";
      this.promotionActive = true;
      this.alertMemo = "Are you sure you want to send approval ?";
      // this.dialog_title = 'Are you sure you want to send approval?'
      // this.active = true;
      this.checkBackdrop = true;
      this.buttonName = "APPROVE";
      this.checkApprove = true;
    },
    clickReject() {
      this.$store.commit("pmmanage/openMemoDialog");
      this.checkEvent = "Reject";
      this.vSetType = "Return";
      this.promotionActive = false;
      this.alertMemo = "Are you sure you want to reject ?";
      // this.dialog_title = 'Are you sure you want to reject ?'
      // this.active = true;
      this.checkBackdrop = true;
      this.buttonName = "REJECT";
    },
    cilckSendToApprove() {
      if (this.optionsPeople.length === 0) {
        this.dContent = "Can not get approve by.";
        this.showSnackbar = true;
        return false;
      } else if (this.selectedPeople === "" || this.selectedPeople === null) {
        this.dContent = "Please select Approval Name.";
        this.showSnackbar = true;
        return false;
      } else {
        this.$store.commit("pmmanage/openMemoDialog");
        this.checkEvent = "Edit";
        this.vSetType = "Pending";
        this.promotionActive = true;
        this.alertMemo = "Are you sure to publish promotion ?";
        // this.dialog_title = 'Are you sure to publish promotion?'
        // this.active = true;
        this.checkBackdrop = true;
        this.buttonName = "SEND TO APPROVE";
      }
    },
    clickClose() {
      this.$store.commit("pmmanage/closeApvDialog");
    },
    // formatNumber(value, dicimal) {
    //     if (isNaN(parseFloat(value))) {
    //         let val = 0;
    //         return val.toFixed(dicimal);
    //         // return value;
    //     } else {
    //         return parseFloat(value).toLocaleString(undefined, {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2
    //         });
    //     }
    // },
    formatNumber(value, dicimal) {
      if (isNaN(parseFloat(value))) {
        let val = 0;
        return val.toFixed(dicimal);
        // return value;
      } else {
        if (value % 1 == 0) {
          return parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal,
          });
        } else {
          let parts = value.toString().split(".");
          let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          let digit = parts[1].slice(0, 3);
          digit = digit.length < 2 ? digit + "0" : digit;
          let rs = num + "." + digit;
          let comma = parseFloat(rs.replace(",", ""));
          // return Math.round(parseFloat(comma) * 100) / 100;
          return parseFloat(
            Math.round(parseFloat(comma) * 100) / 100
          ).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal,
          });
        }
      }
    },
    displayRatio(item) {
      if (item[0] != "" && item[1] != "") {
        return item[0] + " : " + item[1];
      } else {
        return "";
      }
    },
    onClickInfo() {
      this.showInfo = this.showInfo == false ? true : false;
      // this.showSelectedProduct = (this.showSelectedProduct == false) ? true : false;
      // this.showConditionSets = (this.showConditionSets == false) ? true : false;
    },
    onClickSelectedProduct() {
      // this.showInfo = (this.showInfo == false) ? true : false;
      this.showSelectedProduct =
        this.showSelectedProduct == false ? true : false;
      // this.showConditionSets = (this.showConditionSets == false) ? true : false;
    },
    onClickConditionSets() {
      // this.showInfo = (this.showInfo == false) ? true : false;
      // this.showSelectedProduct = (this.showSelectedProduct == false) ? true : false;
      this.showConditionSets = this.showConditionSets == false ? true : false;
    },
    goStep(step) {
      // step = (this.promotion.type == 'Active') ? 'step-1' : step;
      if (this.promotion.type == "Active") {
        this.dialogActivePromo = true;
        this.checkBackdrop = true;
      } else {
        router.replace("/promotion/create");
        this.$store.commit("pmcreate/setStatusAction", "edit");
        this.$store.commit("pmcreate/setPromotion", this.promotion);
        this.$store.commit("pmcreate/setStep", step);
      }
    },
    handleMouseOver() {
      this.showFloatingData = true;
    },
    handleMouseOut() {
      this.showFloatingData = false;
    },
    convertStrategy(type) {
      if(type !== undefined) {
        // this.selectedPmStrategy = this.optionsPmStrategy.find(option => option.number === parseInt(type));
        const pmStrategyIndex = this.optionsPmStrategy.findIndex(option => option.number === parseInt(type));
        // console.log("pmStrategyIndex ==>", pmStrategyIndex);
        if(pmStrategyIndex > -1) {
          this.descriptionPmStrategy = this.optionsPmStrategy[pmStrategyIndex].description;
          this.benefitsPmStrategy = this.optionsPmStrategy[pmStrategyIndex].benefits;
          return this.optionsPmStrategy[pmStrategyIndex].title;
        }
      }
      
      // if (type == "IS") {
      //   return "Increase Sales";
      // } else if (type == "IO") {
      //   return "Increase Outlets";
      // } else if (type == "NP") {
      //   return "New Product";
      // } else if (type == "CP") {
      //   return "Complete";
      // }
    },
    convertDate(date) {
      return moment(new Date(date)).format("MMM D, YYYY");
    },
    convertDateMemo(date) {
      return moment(new Date(date)).format("HH:MM MMMM D, YYYY");
    },
    selectedCondition(promo, cond) {
      // let value = {
      //     row: promo
      // };
      let self = this;
      let user = Vue.$jwt.decode(localStorage.getItem("token"));
      let datas = {
        _id: promo._id,
        user_code: user.code,
      };
      let setDataRow = this.$store.getters["pmmanage/promotions"]
        .map(function (e) {
          return e._id;
        })
        .indexOf(this.promotion._id);

      if (cond.name == "Delete") {
        // this.$store.dispatch("pmmanage/deletePromo", value);
        this.checkEvent = "Delete";
        this.dialog_title = `Are you sure to delete promotion "<b>${promo.promotion_code}</b>"`;
        this.active = true;
        // let setDataRow = this.$store.getters["pmmanage/promotions"].map(function (e) {
        //     return e._id;
        // }).indexOf(this.promotion._id);
        this.promotion_index = setDataRow;
        // this.promotion = promo;
        this.checkBackdrop = true;
      } else if (cond.name == "Duplicate") {
        this.$store.commit("pmmanage/loadingPage", true);
        this.checkDupPromoCode(promo, promo.promotion_code);
        // this.$store.dispatch("pmmanage/duplicatePromo", value);
        /*const promotion = _.cloneDeep(promo);
                delete promotion["_id"];
                router.replace("/promotion/create");
                this.$store.commit("pmcreate/setPromotion", promotion);
                this.$store.commit("pmcreate/setStep", "step-1");*/
      } else if (cond.name == "Track") {
        //this.$store.dispatch("pmmanage/trackPromo", value);
        this.$store.commit("pmmanage/loadingPage", true);
        promotionService.Track(datas).then(() => {
          // self.$store.dispatch("pmmanage/getPromotions");
          promotionService.getPromotions(user.code).then((response) => {
            let selectedRow = response
              .map(function (e) {
                return e.promotion_code;
              })
              .indexOf(
                self.$store.getters["pmmanage/promo_selected"].promotion_code
              );

            self.$store.commit("pmmanage/openApvDialog", response[selectedRow]);
            self.$store.commit("pmmanage/setPromotions", response);
            self.refreshPage ? false : true;
            self.dContent =
              "You have tracking " + promo.promotion_code + " promotion.";
            self.showSnackbar = true;
            self.$store.commit("pmmanage/loadingPage", false);
          });
        });
      } else if (cond.name == "Cancel Tracking") {
        this.$store.commit("pmmanage/loadingPage", true);
        promotionService
          .UnTrack(datas)
          .then(() => {
            promotionService
              .getPromotions(user.code)
              .then((response) => {
                let selectedRow = response
                  .map(function (e) {
                    return e.promotion_code;
                  })
                  .indexOf(
                    self.$store.getters["pmmanage/promo_selected"]
                      .promotion_code
                  );

                self.$store.commit(
                  "pmmanage/openApvDialog",
                  response[selectedRow]
                );
                self.$store.commit("pmmanage/setPromotions", response);
                self.refreshPage ? false : true;
                self.dContent =
                  "You cancel tracking " + promo.promotion_code + " promotion.";
                self.showSnackbar = true;
                self.$store.commit("pmmanage/loadingPage", false);
              })
              .catch();
          })
          .catch();
      } else if (cond.name == "Edit") {
        router.replace("/promotion/create");
        this.$store.commit("pmcreate/setPromotion", promo);
        this.$store.commit("pmcreate/setStep", "step-1");
      } else if (cond.name == "Inactive Promo") {
        this.promoData = promo;
        this.dialogActivePromo = true;
        this.checkBackdrop = true;
      }
    },
    checkDupPromoCode(promo, promo_code, old_promo_id) {
      delete promo["approve_by"];
      let tmpPmCode = {};
      let value = promo_code;
      this.$store
        .dispatch("pmcreate/ck_promotion_code", {
          value,
        })
        .then(() => {
          let ck_promotion = this.$store.state["pmcreate"].ck_promotion;

          if (ck_promotion) {
            this.index_dup_code++;
            if (this.index_dup_code > 1) {
              let split_copy = promo_code.split(" Copy");
              self.copy_promo_code =
                split_copy[0] + " Copy " + this.index_dup_code;
            } else {
              self.copy_promo_code = value + " Copy " + this.index_dup_code;
            }
            this.checkDupPromoCode(
              promo,
              self.copy_promo_code,
              promo.promotion_id
            );
          } else {
            // console.log("promo ==>", promo);
            const promotion = _.cloneDeep(promo);
            // const promotion = JSON.parse(JSON.stringify(promo));
            // console.log("promotion ==>", promotion);
            let products = promotion.products;
            let datas = [];
            products.forEach((item, index) => {
              datas.push(item.code);
            });
            let new_datas = [];
            promotionService
              .getProductUpdate({ code: datas.join(",") })
              .then((rs) => {
                products.forEach((item, index) => {
                  if (rs[item.code] !== undefined) {
                    promotion.products[index].price = rs[item.code].price;
                    promotion.products[index].cost = rs[item.code].cost;
                    new_datas.push(promotion.products[index]);
                  } else {
                    delete promotion.products[index];
                  }
                });
                promotion.products = new_datas;

                let customer_datas = [];
                promotion.sets.forEach((item, index) => {
                  item.customers.forEach((customer, i) => {
                    customer_datas.push(customer.group_name);
                  });
                });
                let new_customer = [];
                promotionService
                  .getCustomerGroupUpdate({ code: customer_datas.join(",") })
                  .then((rs) => {
                    promotion.sets.forEach((item, index) => {
                      new_customer = [];
                      item.customers.forEach((customer, i) => {
                        if (rs[customer._id] !== undefined) {
                          new_customer.push(customer);
                        }
                      });
                      promotion.sets[index].customers = new_customer;
                    });

                    promotion.promotion_code = self.copy_promo_code;
                    promotion.promo_ref =
                      old_promo_id !== undefined ? old_promo_id : "";
                    delete promotion["_id"];
                    delete promotion["type_active"];

                    promotion.wf = [];
                    // router.replace("/promotion/create");
                    // this.$store.commit("pmcreate/setPromotion", promotion);
                    // this.$store.commit("pmcreate/setStep", "step-1");
                    // this.$store.commit("pmmanage/loadingPage", false);
                    this.checkProduct(promotion);

                    this.index_dup_code = 0;
                    return false;
                  });
              })
              .catch();
          }
        })
        .catch();
    },
    checkProduct(item) {
      let product_codes = [];
      let arrPriceType = item.sets[item.sets.length - 1].default_price;
      let dataArray = {};

      for (let i = 0; i < item.products.length; i++) {
        product_codes.push(item.products[i].code);
      }

      promotionService
        .updateRealPriceList({
          product_code: product_codes,
          price_type: arrPriceType,
        })
        .then(async (response) => {
          await promotionService.updatePromotionPrice(item).then((rs) => {
            dataArray = rs;
          });
          await promotionService
            .updateCostConv({ product_code: product_codes })
            .then((rscost) => {
              // console.log("rscost ==>", rscost);
              rscost.forEach(function (value, key) {
                let index = dataArray.products.findIndex((v_data) => {
                  return value.iprod === v_data.code;
                });
                if (index > -1) {
                  dataArray.products[index]["cost_show"] = value.cost_conv
                    ? parseFloat(value.cost_conv)
                    : 0;
                }
              });
            });
          // console.log("dataArray ==>", dataArray);
          router.replace("/promotion/create");
          this.$store.commit("pmcreate/setPromotion", dataArray);
          this.$store.commit("pmcreate/setStep", "step-1");
          this.$store.commit("pmmanage/loadingPage", false);
        });
    },
  },
};
</script>

<style lang="scss">
$color-primary: #3f51b5;
$font-Roboto: Roboto;
$font-Lato: Lato;
$color-green: #64a064;
$color-red: #f44336;

.manage-dialog {
  width: 90%;
  height: 90%;
  max-height: 90% !important;
  // z-index: 6 !important;
  transform: unset !important;
  top: 5% !important;
  left: 10% !important;

  .md-transparent {
    color: #ffffff;
    background-color: #3f51b5;

    .md-icon {
      color: #ffffff;
    }

    .main-title {
      width: 625px;
      padding-top: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 40px;
    }

    .sub-title {
      width: 100px;
      padding-left: 20px;
      text-transform: uppercase;
    }
  }

  .md-card {
    margin: 5px 7px 13px 20px;

    .md-card-header {
      padding: 20px 5px 0 20px;

      .md-card-header-text {
        padding-top: 4px;
      }

      // .mktops-subheader-text {
      //     text-align: unset;
      // }

      .mktops-subheader-text {
        width: 25%;
        font-size: 16px;
        font-family: $font-Lato;
        color: #414141;
        font-weight: bold;

        .md-button:before {
          content: none;
        }
      }
    }
  }

  .mktops-square-blue {
    width: 30px;
    height: 30px;
    background-color: $color-primary;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    font-size: 10px;
    margin-top: 8px;

    .md-icon {
      color: #ffffff;
    }
  }

  .md-tabs-navigation {
    padding-left: unset;
    border-bottom: 1px solid #d7d7d7;
  }

  .md-tab {
    padding: 20px;
  }

  .md-tab-text & .md-tab-blue-text {
    font-size: 14px;
  }

  .md-tab-blue-text {
    color: $color-primary;
    font-size: 12px;
  }

  .md-tab-blue-text.table {
    font-weight: 400;
  }

  .rows-item {
    padding-left: 0px;
    margin-top: 16px;
  }

  .mr-20 {
    margin-right: 20px;
  }

  .mktops-text-condition {
    font-family: Roboto;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .mktops-text-qty {
    font-family: Roboto;
    font-size: 16px;
    color: #000000;
  }

  .section-line {
    border-left: 1px solid #d7d7d7;
    padding-right: 0px !important;
  }

  .section-sub-line {
    border-left: 1px solid #d7d7d7;
    height: 100%;
    width: 5px;
    margin-right: 18px;
  }

  // .fix-height {
  //     height: 300px;
  // }

  .free-item {
    display: flex;
    margin-top: 14px;
    border-left: 1px solid #d7d7d7;
  }

  .-donthavedata {
    font-size: 14px;
    color: #929292;
  }

  .step-content-line {
    margin-top: 14px;
    display: flex;
    padding-left: 10px;
  }

  .filter-chips {
    margin-top: 7px;
    // height: 490px;
    // display: block;
    // overflow-y: scroll;

    .md-chip {
      width: 300px;
      margin-top: 3px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 12px;
    }

    .md-chip.md-theme-default {
      background-color: #3f51b5;
      color: #ffffff;
    }

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }
  }

  .section-sub {
    margin-top: 14px;
    display: flex;
    padding-left: 10px;
  }

  .mktops-produce-table,
  .mktops-info-table {
    .md-table {
      font-family: $font-Roboto;

      .md-toolbar {
        padding-right: unset;
        border-bottom: 0;
      }

      .md-table-head-label {
        font-size: 12px;
        font-family: $font-Roboto;
      }

      .md-table-fixed-header {
        padding: 0 0 0 13px;
        margin-bottom: 5px;
        margin-top: 7px;
      }

      .md-content.md-table-content.md-scrollbar.md-theme-default {
        .md-table-row {
          .md-table-cell-container {
            padding: 0 5px 0 7px;
          }
        }
      }
    }

    .-break-word {
      //   white-space: pre-wrap;
      word-wrap: break-word;
    }
  }

  .mktops-produce-table {
    #table-promotion-repeat {
      padding-bottom: 10px;

      #divTableHead {
        width: 100%;
        display: -webkit-inline-box;
        // font-size: 13px;
        font-weight: bold;
        margin-top: 10px;
        margin-bottom: 5px;

        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;
        font-family: Roboto;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;

          &.-text-right {
            text-align: right;
          }
        }

        &.promotion-set {
          margin-bottom: 0px;
          margin-top: 10px;
          color: #3f51b5;
          font-size: 12px;
          font-weight: 400;
        }
      }

      #divTableBody {
        width: 100%;
        display: block;
        font-size: 14px;

        > div {
          width: 100%;
          height: 35px;
          display: -webkit-inline-box;
          padding-top: 5px;
          padding-bottom: 5px;

          div {
            // border: 1px solid pink;
            padding: 3px 5px 0 5px;

            &.-text-right {
              text-align: right;
            }

            &.nowrap-title {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .row-bg-gray:hover {
          background: rgba(236, 236, 235, 1);
        }
      }
    }

    #table-manage-produce {
      margin-left: 15px;
      margin-right: 5px;
      padding-bottom: 20px;

      #divTableHead {
        width: 99.1%;
        display: -webkit-inline-box;
        // font-size: 13px;
        font-weight: bold;
        margin-top: 15px;
        margin-bottom: 10px;

        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;
        font-family: Roboto;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }
        }
      }

      #divTableFoot {
        width: 99.5%;
        display: -webkit-inline-box;
        font-weight: bold;
        margin-top: 10px;
        margin-bottom: 10px;

        // color: rgba(0, 0, 0, .54);
        font-size: 12px;
        font-family: Roboto;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }
        }
      }

      #divTableBody {
        width: 100%;
        height: calc(320px - 145px);
        display: block;
        overflow-y: scroll;
        font-size: 13px;

        > div {
          width: 100%;
          height: 35px;
          display: -webkit-inline-box;
          padding-top: 5px;
          padding-bottom: 5px;

          div {
            // border: 1px solid pink;
            padding: 3px 5px 0 5px;

            &.-text-right {
              text-align: right;
            }

            &.-text-center {
              text-align: center;
            }

            &.nowrap-title {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            &.-netprice {
              color: #a8a8a8;
            }
          }
        }

        .row-bg-gray:hover {
          background: rgba(236, 236, 235, 1);
        }

        &::-webkit-scrollbar {
          height: 7px;
          width: 5px;
        }
      }
    }

    // #table-manage-basicinfo {
    //     margin-left: 15px;
    //     margin-right: 5px;
    //     padding-bottom: 20px;

    //     #divTableHead {
    //         width: 99.1%;
    //         display: -webkit-inline-box;
    //         // font-size: 13px;
    //         font-weight: bold;
    //         margin-top: 15px;
    //         margin-bottom: 10px;

    //         color: rgba(0, 0, 0, .54);
    //         font-size: 12px;
    //         font-family: Roboto;

    //         div {
    //             // border: 1px solid pink;
    //             padding-left: 5px;
    //             padding-right: 5px;

    //             &.-text-right {
    //                 text-align: right;
    //             }

    //             &.-text-center {
    //                 text-align: center;
    //             }
    //         }
    //     }

    //     #divTableBody {
    //         width: 100%;
    //         height: calc(320px - 145px);
    //         display: block;
    //         font-size: 13px;

    //         >div {
    //             width: 100%;
    //             height: 35px;
    //             display: -webkit-inline-box;
    //             padding-top: 5px;
    //             padding-bottom: 5px;

    //             div {
    //                 // border: 1px solid pink;
    //                 padding: 3px 5px 0 5px;

    //                 &.-text-right {
    //                     text-align: right;
    //                 }

    //                 &.-text-center {
    //                     text-align: center;
    //                 }
    //             }
    //         }
    //     }
    // }
  }

  .mktops-info-table {
    width: 100%;
    text-align: left;
    margin-bottom: 10px;

    .info-table-content {
      border-top: 0;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.87);
      font-weight: 500;
      vertical-align: top;

      &.promotion-repeat {
        font-family: kanit !important;

        > td {
          padding: 5px 0px;
        }
      }
      &.row-bg-gray:hover {
        background: rgba(236, 236, 235, 1);
      }

      > td {
        padding-right: 10px;
      }

      .floating-data-title {
        width: 400px;
        position: fixed;
        right: 20.3%;
        background-color: #b3b3b3;
        border: 1px solid #ccc;
        padding: 10px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        z-index: 999;
        margin-top: 33px;
        color: white;

        &::before {
          content: '';
          position: absolute;
          top: -10px; /* ปรับตำแหน่งบนของสามเหลี่ยม */
          left: 50%; /* จากตรงกลางของ .floating-data-title */
          margin-left: -5px; /* ปรับตำแหน่งแนวนอนของสามเหลี่ยม */
          border-width: 0 10px 10px;
          border-style: solid;
          border-color: transparent transparent #b3b3b3;
        }
      }
    }

    .info-table-head > th {
      color: rgba(0, 0, 0, 0.54);
      font-weight: bold;
    }
  }

  .content-md-drawer {
    margin-right: 4px;
    overflow-y: scroll;
    height: calc(100vh - 80px);
  }

  .content-md-drawer::-webkit-scrollbar {
    height: 7px;
    width: 5px;
    background: #f7f7f7;
  }

  .content-md-drawer::-webkit-scrollbar-thumb {
    background-color: #f7f7f7;
    border-radius: 5px;
  }

  .md-dialog-container {
    width: 100%;
  }

  .md-toolbar {
    background-color: white !important;
    box-shadow: unset !important;
    border-bottom: 0 !important;

    .title-panel {
      // position: fixed;
      width: 80%;
      font-size: 18px;
      font-weight: 500;
      padding: 8px 15px 0;
    }

    .sub-title {
      width: 15%;
      text-align: right;
      padding-top: 8px;
    }

    .md-menu {
      width: 5%;
      text-align: right;
      padding-top: 8px;

      .more-vert {
        height: 25px;
        width: 25px;
        min-width: 25px;
      }
    }
  }

  .content-promotion-manage {
    width: 100%;
    overflow-y: scroll;
    height: calc(90vh - 135px);
    // padding-left: 20px;
    padding-right: 10px;
    background-color: #f7f7f7;

    > div {
      // display: inline;
      position: initial;
    }

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }

    .condition-sets {
      #table-manage-promotions {
        margin-left: 20px;
        margin-right: 5px;
        // padding-bottom: 20px;
        width: 95%;

        #divTableHead {
          width: 100%;
          display: -webkit-inline-box;
          // font-size: 13px;
          font-weight: bold;
          margin-top: 15px;
          margin-bottom: 10px;

          color: rgba(0, 0, 0, 0.54);
          font-size: 12px;
          font-family: Roboto;

          div {
            // border: 1px solid pink;
            padding-left: 5px;
            padding-right: 5px;

            &.-text-right {
              text-align: right;
            }

            &.-text-center {
              text-align: center;
            }
          }
        }

        #divTableBody {
          width: 100%;
          font-size: 13px;

          > div {
            width: 100%;
            height: 35px;
            display: -webkit-inline-box;
            padding-top: 5px;
            padding-bottom: 5px;

            div {
              // border: 1px solid pink;
              padding: 3px 5px 0 5px;

              &.-text-right {
                text-align: right;
              }

              &.-text-center {
                text-align: center;
              }

              &.nowrap-title {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              &.-netprice {
                color: #a8a8a8;
              }
            }
          }

          .row-bg-gray:hover {
            background: rgba(236, 236, 235, 1);
          }

          &::-webkit-scrollbar {
            height: 7px;
            width: 5px;
          }
        }
      }
    }

    .btn-none {
      height: 36px;
    }

    .content-memo {
      // height: 300px;
      // overflow-y: scroll;
      background-color: #ffffff;
      padding: 15px;

      .item-card {
        // height: 80px;
        // margin: 5px 5px 8px 5px;
        cursor: text;
        padding: 5px;

        // &.row-bg-orange {
        //     div {
        //         // border-radius: 4px;
        //         background: #FDF5DF;
        //     }
        // }

        // &.row-bg-green {
        //     div {
        //         // border-radius: 4px;
        //         // background: #efffef;
        //         background: #edf0ff;
        //     }
        // }

        &.row-bg-gray {
          div {
            background-color: #f1f1f1;
          }
        }
        &.row-bg-green {
          div {
            background-color: #f5fdf3;
          }
        }
        &.row-bg-red {
          div {
            background-color: #fff3f2;
          }
        }
        &.row-bg-yellow {
          div {
            background-color: #fff7e5;
          }
        }
        &.row-bg-blue {
          div {
            background-color: #eaf5ff;
          }
        }

        .nowrap-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .md-list-item-container {
          display: flex;
        }

        .-title {
          font-size: 13px;
          color: #767676;

          .memo-chip {
            padding-left: 5px;
            padding-right: 5px;
            border-radius: 50px;
            color: #ffffff;
            font-size: 11px;
            margin-left: 5px;
            max-height: 16px;
            line-height: 16px;

            &.-gray {
              background-color: #a8a8a8;
            }
            &.-green {
              background-color: #64a064;
            }
            &.-red {
              background-color: #f44336;
            }
            &.-yellow {
              background-color: #fbc02d;
            }
            &.-blue {
              background-color: #2b9cfd;
            }
          }
        }

        .-date {
          margin-top: 5px;
          color: #a8a8a8;
        }

        .-comment {
          // margin-top: 10px;
          color: #727272;
          padding-left: 12px !important;
          padding-top: 5px;
          padding-bottom: 10px;

          &.-italic {
            font-style: italic;
          }
        }

        .-left-panel {
          width: 7%;
          .-circle-gray {
            width: 36px;
            height: 36px;
            // background-color: #EFEFEF;
            background-color: #cecece;
            border-radius: 4px;
            margin-top: 5px;
            margin-left: 10px;
          }
        }

        .-right-panel {
          width: 93%;
        }
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }

      &::-webkit-scrollbar-track {
        background-color: #ffffff;
      }
    }
  }

  .-action {
    position: absolute;
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;

    .md-button {
      margin-right: 0px !important;
      margin-top: 5px;
    }

    .md-ripple {
      width: 100%;
      margin: 0;
    }

    .-cancel {
      color: #727272 !important;
      margin-right: 10px;
    }

    .-approve {
      color: $color-green;
    }

    .-reject {
      color: $color-red;
    }

    .multiselect {
      .z-index-top {
        z-index: 10;
      }

      margin: 5px 0px;

      .multiselect__single,
      .multiselect__input {
        font-size: 14px;

        div {
          display: flex;
          width: 100%;

          .-delete {
            width: 10%;

            .material-icons {
              font-size: 18px;
              margin-top: 1px;
              cursor: pointer;
              color: gray;
            }
          }
        }
      }

      .multiselect__tags {
        padding: 8px 30px 0 8px;

        input {
          font-family: lato;
          font-weight: 300;
        }

        .multiselect__placeholder {
          margin: 0px;
        }

        ::placeholder {
          color: #bdbdbd;
          opacity: 1;
        }
      }

      .multiselect__content-wrapper,
      .multiselect__content {
        font-size: 14px;
        z-index: 100;
      }

      .multiselect__option {
        min-height: 34px;
        padding: 12px 12px 0px 12px;
      }

      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
    }
  }

  .-inactive-product,
  .-inactive-product .-netprice {
    // background-color: #ffd6d6;
    // color: #A8A8A8 !important;
    color: red !important;
    font-style: italic;
  }

  .select-approval {
    width: 20%;
    margin: 0px 25px;

    .md-field:after,
    .md-field:before {
      left: unset;
    }

    .md-field.md-theme-default,
    .md-field.md-theme-default.md-has-value {
      margin-bottom: 5px;
      margin-top: 0px;
      padding-top: 12px;
    }

    .md-select {
      background-color: #efefef;
      border-radius: 3px;

      input {
        padding-left: 15px;
      }
    }
  }
}

.manage-dialog:hover {
  .content-md-drawer::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.12);
  }
}

.md-menu-content-big.menu-vert-manage {
  z-index: 20;
  // top: 95px !important;
  // right: 225px !important;
  top: 8% !important;
  right: 13% !important;
  left: unset !important;
  max-height: 37vh !important;
  min-width: 112px !important;
  max-width: 280px !important;
}

.bg-backdrop-promotion {
  background: rgba(0, 0, 0, 0.35);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 18;
  top: 0;
  left: 0;
}
.backdrop-manage {
  background: rgba(0, 0, 0, 0.35);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 15;
  top: 0;
  left: 0;
}
</style>
